module.exports = __webpack_public_path__ + "img/img14.f8ab53b4.svg";